(function( $ ) {

	"use strict";
	
	// javascript code here. i.e.: $(document).ready( function(){} ); 
	
     $( document ).ready(function() {
          $("#input_10_6").on('input', function(e) {
              $(this).val($(this).val().replace(/[^+0-9]/g, ''));
          });
          $(document).on('gform_post_render', function(event, form_id, current_page){
              $("#input_10_6").on('input', function(e) {
                  $(this).val($(this).val().replace(/[^+0-9]/g, ''));
              });
          });
      });
})(jQuery);